import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('App error:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-paper p-6">
          <div className="card max-w-md w-full p-6 text-center">
            <div className="text-2xl mb-2">حدث خطأ غير متوقع</div>
            <div className="text-ink-2 mb-4 text-sm">{String(this.state.error.message || this.state.error)}</div>
            <button className="btn btn-primary" onClick={() => window.location.reload()}>
              إعادة تحميل
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
